export default {
  'servers.title': 'Configuración de Servidores y Servicios Azure',
  'servers.azureGraph': 'Azure Graph',
  'servers.azureGraphSharePoint': 'Azure Graph - Share Point',
  'servers.emailServer': 'Servidor de Correo',
  'servers.powerBiServer': 'Servidor Power BI',
  'servers.addConfiguration': 'Agregar configuración',

  'servers.azureGraphSharePointConfiguration': 'Configuración Azure Graph - Share Point',
  'servers.azureGraphConfiguration': 'Configuración Azure Graph',
  'servers.emailServerConfiguration': 'Configuración Servidor de Correo',
  'servers.powerBIServerConfiguration': 'Configuración Servidor Power BI',
  'servers.form.clientId': 'Cliente',
  'servers.form.username': 'Usuario',
  'servers.form.password': 'Contraseña',

  'servers.form.serverType': 'Tipo',
  'servers.form.fromEmail': 'Correo',
  'servers.form.fromName': 'Nombre',
  'servers.form.port': 'Puerto',
  'servers.form.enableSsl': 'Habilitar SSL',
  'servers.form.useDefaultCredentials': 'Usar Credenciales Predeterminadas',
  'servers.form.clientSecret': 'Secreto del Cliente',
  'servers.form.isAutoManaged': 'Es Autogestionado',
  'servers.form.authorityUrl': 'Url de Autorización',
  'servers.form.resourceUrl': 'Resource Url',
  'servers.form.apiUrl': 'Api Url',
  'servers.form.embedUrlBase': 'EmbedUrl Base',
  'servers.form.redirectUrl': 'Redirect Url',
  'servers.form.sharePointCompanyUrl': 'Url de la Empresa',
};
